export default class NotificationDropdownController {
    constructor() {
        const element = document.querySelector(".js-notification");

        if (element) {
            import(/* webpackChunkName: "NotificationDropdown" */ "../classes/NotificationDropdown").then(res => {
                const NotificationDropdown = res.default;
                this.createInstance(NotificationDropdown, element);
            });
        }
    }

    createInstance(NotificationDropdown, element) {
        return new NotificationDropdown(element);
    }
}
